import './goosebeachbar/style';
import FormStructure from './goosebeachbar/form_structure';

export default FormStructure;